import { render, staticRenderFns } from "./VersionMultiselect.vue?vue&type=template&id=d94b9520&"
import script from "./VersionMultiselect.vue?vue&type=script&lang=js&"
export * from "./VersionMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./VersionMultiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports